"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "centify", {
  enumerable: true,
  get: function get() {
    return _centify2.centify;
  }
});
exports.convertCurrency = convertCurrency;
Object.defineProperty(exports, "yuanify", {
  enumerable: true,
  get: function get() {
    return _yuanify2.yuanify;
  }
});

var _cloneNonReference = require("./share/cloneNonReference");

var _yuanify2 = require("./yuanify");

var _centify2 = require("./centify");

/**
 * 价格转换
 * @description
 * 分离 data 与 paths 同时调用主要为了解决 `data` `paths` 同时存在会出现解析缓慢问题
 */
function convertCurrency(data) {
  var result = (0, _cloneNonReference.cloneNonReference)(data);
  return {
    origin: data,
    data: result,
    yuanify: function yuanify(paths) {
      (0, _yuanify2.yuanify)(result, paths);
      return result;
    },
    centify: function centify(paths) {
      (0, _centify2.centify)(result, paths);
      return result;
    }
  };
}